var CHECKERBOARD_BACKGROUND = 'var(--xcwxf61, url(\'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSIyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDBoMnYySDB6IiBmaWxsPSIjZmZmIi8+CiAgPHBhdGggZD0iTTAgMGgxdjJoMVYxSDAiIGZpbGw9IiNlMWUxZTEiLz4KPC9zdmc+\')) 0 0 / calc(var(--xcwxf60, 0.25rem) * 2) calc(var(--xcwxf60, 0.25rem) * 2)';
var CHECKERBOARD_CHECK_SIZE_VAR = 'var(--xcwxf60)';

export { CHECKERBOARD_BACKGROUND, CHECKERBOARD_CHECK_SIZE_VAR };
//# sourceMappingURL=checkerboard.css.js.map
